import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "title-bar v-row" }
const _hoisted_2 = {
  class: "v-row fixed-left-bar",
  style: {"padding":"4px"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  class: "v-row option-container",
  style: {"margin":"0 4px 0 16px"}
}
const _hoisted_6 = {
  class: "v-column",
  style: {"color":"var(--text-base)","font-size":"18px","flex":"1","justify-content":"space-around"}
}
const _hoisted_7 = { class: "v-row" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" VIP等级：")
const _hoisted_9 = ["src"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("退出")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_text_field = _resolveComponent("text-field")!
  const _component_window_state_bar = _resolveComponent("window-state-bar")!
  const _component_hl_button = _resolveComponent("hl-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.user.uin)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            alt: "",
            class: "user-icon cover",
            src: _ctx.user.headURI,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loginModal = true))
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createBlock(_component_icon, {
            key: 1,
            name: "user-circle",
            class: "user-icon",
            onClick: _ctx.login
          }, null, 8, ["onClick"])),
      _createElementVNode("span", {
        class: "user-name",
        title: _ctx.user.nickName,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.user.uin ? (_ctx.loginModal = true) : _ctx.login($event)))
      }, _toDisplayString(_ctx.user.uin ? _ctx.user.nickName : '点击登录'), 9, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_icon, {
        class: _normalizeClass(["back", {disabled: _ctx.backLength === 0}]),
        name: "back",
        style: {"margin-left":"0"},
        onClick: _ctx.back
      }, null, 8, ["class", "onClick"]),
      _createVNode(_component_icon, {
        class: _normalizeClass(["forward", {disabled : _ctx.forwardLength === 0}]),
        name: "back",
        style: {"transform":"rotate(180deg)"},
        onClick: _ctx.forward
      }, null, 8, ["onClick", "class"]),
      _createVNode(_component_icon, {
        name: "refresh",
        onClick: _ctx.refresh,
        style: {"margin":"0 8px 0 0"}
      }, null, 8, ["onClick"]),
      _createVNode(_component_text_field, {
        placeholder: "请输入内容",
        modelValue: _ctx.searchInput,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchInput) = $event)),
        suffixIcon: "search",
        onKeyup: _withKeys(_ctx.openNetSearchView, ["enter"])
      }, null, 8, ["modelValue", "onKeyup"])
    ]),
    _createVNode(_component_window_state_bar, null, {
      default: _withCtx(() => [
        _createVNode(_component_icon, {
          class: "icon-menu skin viewer-hidden",
          name: "skin"
        }),
        _createVNode(_component_icon, {
          class: "icon-menu setting viewer-hidden",
          name: "setting",
          onClick: _ctx.openSystemSetting
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_modal, {
      title: "QQ登录",
      id: "login-modal",
      width: "600px",
      height: "400px",
      visible: _ctx.loginModal,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loginModal) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, "账号：" + _toDisplayString(_ctx.user.uin), 1),
          _createElementVNode("div", null, "昵称：" + _toDisplayString(_ctx.user.nickName), 1),
          (_ctx.user.level)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("img", {
                    alt: "",
                    class: "cover",
                    style: {"margin":"-0.5em 0 0 0"},
                    src: _ctx.user.levelIconURI
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("span", null, "会员开通时间：" + _toDisplayString(_ctx.user.startTime), 1),
                _createElementVNode("span", null, "会员到期时间：" + _toDisplayString(_ctx.user.endTime), 1),
                (_ctx.user.autoPay)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "已开启自动续费"))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_hl_button, { onClick: _ctx.logout }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}